import MessageForum from './MessageForum';

export default MessageForum;
